/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class ComparisonTable extends HTMLElement {
  #controller = new AbortController();
  connectedCallback() {
    const swiperEl = this.querySelector('.comparison-table__swiper');
    if (swiperEl?.classList.contains('swiper-initialized')) {
      this.#syncRowHeights();
    } else if (swiperEl) {
      const mo = new MutationObserver(() => {
        if (swiperEl.classList.contains('swiper-initialized')) {
          mo.disconnect();
          this.#syncRowHeights();
        }
      });
      mo.observe(swiperEl, {
        attributes: true,
        attributeFilter: ['class']
      });
      this.#controller.signal.addEventListener('abort', () => mo.disconnect(), {
        once: true
      });
    }
    const ro = new ResizeObserver(() => this.#syncRowHeights());
    this.querySelectorAll('.comparison-table__product-heading, .comparison-table__product-img').forEach(el => ro.observe(el));
    this.#controller.signal.addEventListener('abort', () => ro.disconnect(), {
      once: true
    });
    window.addEventListener('resize', this.#onResize, {
      signal: this.#controller.signal,
      passive: true
    });
    this.addEventListener('comparison:variant-updated', this.#onVariantUpdated, {
      signal: this.#controller.signal
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
  }
  #onResize = () => {
    this.#syncRowHeights();
  };
  #onVariantUpdated = () => {
    requestAnimationFrame(() => this.#syncRowHeights());
  };
  #syncRowHeights() {
    this.querySelectorAll('[data-row]').forEach(el => {
      el.style.minHeight = '';
    });
    const rowGroups = new Map();
    this.querySelectorAll('[data-row]').forEach(el => {
      const key = el.dataset.row;
      if (!rowGroups.has(key)) rowGroups.set(key, []);
      rowGroups.get(key).push(el);
    });
    rowGroups.forEach(cells => {
      const max = Math.max(...cells.map(c => c.offsetHeight));
      cells.forEach(c => {
        c.style.minHeight = max + 'px';
      });
    });
    if (!this.classList.contains('is-synced')) {
      const swiperEl = this.querySelector('.comparison-table__swiper');
      if (swiperEl?.classList.contains('swiper-initialized')) {
        this.classList.add('is-synced');
      }
    }
  }
}
if (!customElements.get('comparison-table')) {
  customElements.define('comparison-table', ComparisonTable);
}
class ComparisonVariantSwatch extends HTMLElement {
  #controller = new AbortController();
  #fetchCtrl = null;
  #column = null;
  connectedCallback() {
    this.#column = this.closest('.comparison-table__column');
    this.addEventListener('change', this.#onChange, {
      signal: this.#controller.signal
    });
  }
  disconnectedCallback() {
    this.#controller.abort();
    this.#fetchCtrl?.abort();
  }
  #onChange = e => {
    this.#updateActiveState(e.target.value);
    this.#fetchVariant(e.target.value);
  };
  #fetchVariant(variantId) {
    this.#fetchCtrl?.abort();
    this.#fetchCtrl = new AbortController();
    const handle = this.dataset.productHandle;
    fetch(`/products/${handle}.js`, {
      signal: this.#fetchCtrl.signal
    }).then(r => r.json()).then(product => {
      const variant = product.variants.find(v => v.id === Number(variantId));
      if (!variant) return;
      this.#updateImage(variant);
      this.#updateCta(variant);
      this.dispatchEvent(new CustomEvent('comparison:variant-updated', {
        bubbles: true
      }));
    }).catch(e => {
      if (e.name !== 'AbortError') console.error('comparison-variant-swatch:', e);
    });
  }
  #updateImage(variant) {
    if (!variant.featured_image) return;
    const img = this.#column?.querySelector('.comparison-table__product-img');
    if (!img) return;
    img.src = variant.featured_image.src;
    img.srcset = '';
  }
  #updateCta(variant) {
    const ctaButton = this.#column?.querySelector('.comparison-table__cta-button');
    if (!ctaButton) return;
    const price = this.#formatMoney(variant.price);
    const productId = `comparison-${this.dataset.sectionId}-product-${this.dataset.productId}`;
    if (variant.available) {
      const atcEl = ctaButton.querySelector('add-to-cart');
      if (atcEl) {
        atcEl.dataset.variantId = variant.id;
        const priceEl = atcEl.querySelector('.comparison-table__atc-price');
        if (priceEl) priceEl.textContent = price;
      } else {
        ctaButton.innerHTML = `<add-to-cart class="comparison-table__atc-btn" data-variant-id="${variant.id}"><span class="comparison-table__atc-label">${this.dataset.addToCart}</span><span class="comparison-table__atc-price">${price}</span></add-to-cart>`;
      }
    } else {
      const qvDrawer = document.querySelector(`quick-view-drawer[data-product-id="${productId}"]`);
      if (qvDrawer) {
        ctaButton.innerHTML = `<quick-view-button class="comparison-table__qv-btn button button--full-width" data-product-id="${productId}" data-product-url="/products/${this.dataset.productHandle}" disabled="disabled" aria-disabled="true" tabindex="-1" role="button">${this.dataset.soldOut}</quick-view-button>`;
      } else {
        ctaButton.innerHTML = `<button class="comparison-table__qv-btn button button--full-width" disabled>${this.dataset.soldOut}</button>`;
      }
    }
    const qv = document.querySelector(`quick-view-drawer[data-product-id="${productId}"] quick-view`);
    if (qv) qv.dataset.variantId = variant.id;
  }
  #updateActiveState(variantId) {
    this.querySelectorAll('.comparison-table__variant-option').forEach(label => {
      const input = label.querySelector('input');
      label.classList.toggle('is-active', input?.value === variantId);
    });
  }
  #formatMoney(cents) {
    if (window.theme?.Currency?.formatMoney && window.theme?.shopSettings?.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.shopSettings.moneyFormat);
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    }).format(cents / 100);
  }
}
if (!customElements.get('comparison-variant-swatch')) {
  customElements.define('comparison-variant-swatch', ComparisonVariantSwatch);
}
/******/ })()
;